import { styled } from 'styled-components';

import { useTypedParams } from '@sorare/routing';

import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { desktopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { MatchView } from '@sorare/gameplay/src/components/MatchView';

const Root = styled.div`
  --container-padding: var(--intermediate-unit);
  padding: 0 0 var(--container-padding);

  @media ${desktopAndAbove} {
    --container-padding: var(--triple-unit);
    padding-bottom: 0;
  }
`;

export const ScoutingCenterGameIdBoxScorePage = () => {
  const { gameId } = useTypedParams();
  const isLaptop = useIsLaptop();

  return (
    <Root>
      <MatchView desktop={isLaptop} id={gameId} highlightInLineupPlayers />
    </Root>
  );
};

export default ScoutingCenterGameIdBoxScorePage;
